import * as React from "react";

import Layout from "../components/layout";
import Jobs from "../components/Careers/Jobs";
// import Inquiries from "../components/Home/Inquiries";
// import { Link } from "gatsby"

import Seo from "../components/seo";

const Careers = () => (
  <Layout>
    <Seo
      title="Careers"
      description="Explore open positions across the S.T.A.R. Services Group - port operations, engineering, administration, and logistics roles in the Philippines."
      pathname="/careers/"
    />
    <Jobs />
    {/* <Inquiries /> */}
  </Layout>
);

export default Careers;
